export var API_ENDPOINT = '/overview';
export var LOADER_KEY = 'overview';
export var REDUCER_KEY = 'overview';
export var TOP_CHANNELS_DATE_RANGE_LABEL = 'Last Month';
export var TOP_INVENTORY_DATE_RANGE_LABEL = 'Last 2 Weeks';
export var SHOPPER_ACTIVITY_DATE_RANGE_LABEL = 'Last 30 days';